import { makeAutoObservable, runInAction } from 'mobx'
import InputStore from '../../../stores/InputStore'
import CasesService from '../../../services/CasesService'
import { string } from 'yup'

class CaseCheckoutCashStore {
  constructor (caseDetailStore) {
    this.isLoading = false
    this.firstName = new InputStore(string().matches(/^[\p{L} ,.'-]+$/u, 'Invalid First Name. Only letters are allowed').required('First Name is required'))
    this.lastName = new InputStore(string().matches(/^[\p{L} ,.'-]+$/u, 'Invalid Last Name. Only letters are allowed').required('Last Name is required'))
    this.phone = new InputStore(string().matches(/^(\+\d{6,}|\d{6,})$/, 'Invalid Phone Number. Please enter a valid phone number').required('Phone Number is required'))
    this.email = new InputStore(
      string().email('Email must be a valid email address').required('Email is required')
    )
    this.agreedTerms = false
    this.globalError = ''
    this.termsError = false

    makeAutoObservable(this)

    this.caseDetailStore = caseDetailStore
    this.casesService = new CasesService()
  }

  changeFirstName (val) {
    this.firstName.setValue(val)
  }

  changeLastName (val) {
    this.lastName.setValue(val)
  }

  changePhone (val) {
    this.phone.setValue(val)
  }

  changeEmail (val) {
    this.email.setValue(val)
  }

  toggleTerms () {
    this.agreedTerms = !this.agreedTerms
    this.termsError = false
  }

  clearErrors () {
    this.globalError = ''
    this.termsError = false
    this.firstName.clearError()
    this.lastName.clearError()
    this.phone.clearError()
    this.email.clearError()
  }

  async validate () {
    this.clearErrors()
    let isValid = true

    if (!(await this.firstName.validate())) {
      isValid = false
    }

    if (!(await this.lastName.validate())) {
      isValid = false
    }

    if (!(await this.phone.validate())) {
      isValid = false
    }

    if (!(await this.email.validate())) {
      isValid = false
    }

    if (!this.agreedTerms) {
      runInAction(() => {
        this.termsError = true
      })
      isValid = false
    }

    return isValid
  }

  async checkout () {
    if (await this.validate()) {
      runInAction(() => {
        this.isLoading = true
      })

      try {
        const immobilizationCase = await this.casesService.checkoutCash(
          this.caseDetailStore.immobilizationCase.slug,
          this.firstName.value,
          this.lastName.value,
          this.phone.value,
          this.email.value
        )

        runInAction(() => {
          this.isLoading = false
        })

        return immobilizationCase
      } catch (e) {
        runInAction(() => {
          const displayedError = this.parseRequestErrors(e.response?.data?.errors || {})

          if (!displayedError) {
            this.globalError = 'Something went wrong, please check the provided data and try again.'
          }

          this.isLoading = false
        })
      }
    }

    return false
  }

  parseRequestErrors (messages) {
    const keys = Object.keys(messages)
    let displayedError = false

    keys.forEach((key) => {
      const [error] = messages[key]

      switch (key) {
        case 'firstname':
          this.firstName.setError(true, error)
          displayedError = true
          break

        case 'lastname':
          this.lastName.setError(true, error)
          displayedError = true
          break

        case 'phone':
          this.phone.setError(true, error)
          displayedError = true
          break

        case 'email':
          this.email.setError(true, error)
          displayedError = true
          break

        default:
          break
      }
    })

    return displayedError
  }
}

export default CaseCheckoutCashStore
